(function() {
  var NAV_SELECTOR = '[data-cpilot-family-navigation]';
  var ITEM_SELECTOR = '[data-cpilot-family-item]';
  var DATA_SELECTOR = '[data-cpilot-family-navigation-products]';
  var STATE_SELECTOR = '[data-cpilot-family-navigation-state]';
  var STATUS_SELECTOR = '[data-cpilot-family-navigation-status]';
  var CLEAR_SIZE_SELECTOR = '[data-cpilot-family-navigation-clear-size]';
  var navigationRequestId = 0;

  function getProductSection(nav) {
    return nav.closest('.shopify-section');
  }

  function getSectionId(section) {
    if (!section || !section.id) return '';
    return section.id.replace(/^shopify-section-/, '');
  }

  function currentUrlHasVariant() {
    try {
      return new URL(window.location.href).searchParams.has('variant');
    } catch (error) {
      return false;
    }
  }

  function initializeSizeIntent(nav) {
    if (!nav || nav.dataset.cpilotSizeIntent) return;
    nav.dataset.cpilotSizeIntent = currentUrlHasVariant() ? 'url' : 'none';
  }

  function setExplicitSizeIntent(nav, source) {
    if (!nav) return;
    nav.dataset.cpilotSizeIntent = source || 'user';
  }

  function clearSizeIntent(nav) {
    if (!nav) return;
    nav.dataset.cpilotSizeIntent = 'none';
  }

  function hasExplicitSizeIntent(nav) {
    initializeSizeIntent(nav);
    return nav.dataset.cpilotSizeIntent !== 'none';
  }

  function getNavigationData(nav) {
    if (nav.cpilotFamilyData) return nav.cpilotFamilyData;

    var dataEl = nav.querySelector(DATA_SELECTOR);
    if (!dataEl) {
      nav.cpilotFamilyData = { products: [] };
      return nav.cpilotFamilyData;
    }

    try {
      nav.cpilotFamilyData = JSON.parse(dataEl.textContent);
    } catch (error) {
      nav.cpilotFamilyData = { products: [] };
    }

    return nav.cpilotFamilyData;
  }

  function getProductScope(nav) {
    return nav.closest('.product-form') || nav.closest('.js-product') || document;
  }

  function getSelectedSize(nav) {
    var productScope = getProductScope(nav);
    var checkedInput = productScope.querySelector('variant-picker .option-selector[data-option="Size"] input:checked');
    if (checkedInput && checkedInput.value) {
      return checkedInput.value.trim().toUpperCase();
    }

    var selectedOption = productScope.querySelector('variant-picker .option-selector[data-option="Size"] .custom-select__option[aria-selected="true"]');
    if (selectedOption && selectedOption.dataset.value) {
      return selectedOption.dataset.value.trim().toUpperCase();
    }

    return '';
  }

  function productByHandle(data, handle) {
    if (!data || !Array.isArray(data.products)) return null;
    return data.products.find(function(product) {
      return product.handle === handle;
    }) || null;
  }

  function getActiveProduct(nav, data) {
    var activeItem = nav.querySelector(ITEM_SELECTOR + '.is-active');
    if (!activeItem) return null;
    return productByHandle(data, activeItem.dataset.cpilotProductHandle);
  }

  function productHasAvailableVariant(product) {
    if (!product || !product.variantsBySize) return false;

    return Object.keys(product.variantsBySize).some(function(size) {
      return Boolean(product.variantsBySize[size] && product.variantsBySize[size].available);
    });
  }

  function allProductsSoldOut(data) {
    if (!data || !Array.isArray(data.products) || !data.products.length) return false;

    return data.products.every(function(product) {
      return !productHasAvailableVariant(product);
    });
  }

  function setStatus(nav, message, showClear) {
    var state = nav.querySelector(STATE_SELECTOR);
    var status = nav.querySelector(STATUS_SELECTOR);
    var clearButton = nav.querySelector(CLEAR_SIZE_SELECTOR);
    var hasMessage = Boolean(message);

    if (status) {
      status.textContent = message || '';
    }

    if (clearButton) {
      clearButton.hidden = !showClear;
    }

    if (state) {
      state.hidden = !hasMessage && !showClear;
    }
  }

  function getItemLabel(item) {
    return (
      item.dataset.cpilotColourLabel ||
      item.dataset.cpilotOriginalLabel ||
      item.getAttribute('aria-label') ||
      item.textContent.trim() ||
      'This colour'
    );
  }

  function announceUnavailable(nav, item) {
    var label = item.getAttribute('aria-label') || getItemLabel(item) + ' is not available';
    setStatus(nav, label + '.', hasExplicitSizeIntent(nav));
  }

  function setItemAvailable(item, available, url, selectedSize) {
    var originalLabel = getItemLabel(item);
    item.dataset.cpilotOriginalLabel = originalLabel;

    item.classList.toggle('is-unavailable', !available);
    item.dataset.cpilotUnavailable = available ? 'false' : 'true';

    if (available) {
      if (url) {
        item.href = url;
      }
      item.removeAttribute('aria-disabled');
      item.removeAttribute('tabindex');
      item.removeAttribute('role');
      item.setAttribute('aria-label', originalLabel);
      item.setAttribute('title', originalLabel);
      return;
    }

    item.removeAttribute('href');
    item.setAttribute('aria-disabled', 'true');
    item.setAttribute('tabindex', '0');
    item.setAttribute('role', 'button');

    if (selectedSize) {
      var unavailableLabel = originalLabel + ', not available in size ' + selectedSize;
      item.setAttribute('aria-label', unavailableLabel);
      item.setAttribute('title', unavailableLabel);
    }
  }

  function updateAvailability(nav) {
    initializeSizeIntent(nav);

    var data = getNavigationData(nav);
    var selectedSize = getSelectedSize(nav);
    var explicitSizeIntent = Boolean(selectedSize && hasExplicitSizeIntent(nav));
    var availableForSelectedSizeCount = 0;

    nav.querySelectorAll(ITEM_SELECTOR).forEach(function(item) {
      var product = productByHandle(data, item.dataset.cpilotProductHandle);
      var baseUrl = item.dataset.cpilotProductUrl;

      if (!item.dataset.cpilotOriginalHref && item.getAttribute('href')) {
        item.dataset.cpilotOriginalHref = item.getAttribute('href');
      }

      if (!explicitSizeIntent || !product) {
        setItemAvailable(item, true, baseUrl || item.dataset.cpilotOriginalHref, '');
        return;
      }

      var sizeVariant = product.variantsBySize && product.variantsBySize[selectedSize];
      var isAvailable = Boolean(sizeVariant && sizeVariant.available && sizeVariant.url);
      if (isAvailable) {
        availableForSelectedSizeCount += 1;
      }

      setItemAvailable(item, isAvailable, isAvailable ? sizeVariant.url : '', selectedSize);
    });

    var statusMessage = '';
    var showClear = explicitSizeIntent;

    if (explicitSizeIntent) {
      statusMessage = availableForSelectedSizeCount > 0
        ? 'Showing colours available in size ' + selectedSize
        : 'No colours available in size ' + selectedSize;
    } else if (allProductsSoldOut(data)) {
      statusMessage = 'This family is currently sold out.';
    } else {
      var activeProduct = getActiveProduct(nav, data);
      if (activeProduct && !productHasAvailableVariant(activeProduct)) {
        statusMessage = 'This colour is currently sold out. Choose another colour from the options shown.';
      }
    }

    setStatus(nav, statusMessage, showClear);
  }

  function buildSectionUrl(targetUrl, sectionId) {
    var url = new URL(targetUrl, window.location.origin);
    url.searchParams.set('sections', sectionId);
    return url;
  }

  function reinitializeSection(section) {
    window.setTimeout(function() {
      initCommercePilotFamilyNavigation(section);

      if (
        window.CommercePilotTeeDecisionBlock &&
        typeof window.CommercePilotTeeDecisionBlock.init === 'function'
      ) {
        window.CommercePilotTeeDecisionBlock.init();
      }

      section.dispatchEvent(new CustomEvent('shopify:section:load', {
        bubbles: true,
        detail: {
          sectionId: getSectionId(section)
        }
      }));
    }, 0);
  }

  function replaceProductSection(currentSection, sectionHtml) {
    if (!currentSection || !sectionHtml) return null;

    var parsedDocument = new DOMParser().parseFromString(sectionHtml, 'text/html');
    var replacementSection = parsedDocument.getElementById(currentSection.id) || parsedDocument.body.firstElementChild;

    if (!replacementSection) return null;

    currentSection.replaceWith(replacementSection);
    reinitializeSection(replacementSection);
    return replacementSection;
  }

  function navigateToProduct(targetUrl, nav, options) {
    var section = getProductSection(nav);
    var sectionId = getSectionId(section);
    var requestId = ++navigationRequestId;
    var updateHistory = !options || options.updateHistory !== false;

    if (!section || !sectionId) {
      window.location.assign(targetUrl);
      return Promise.resolve();
    }

    section.classList.add('cpilot-family-navigation-is-loading');

    return fetch(buildSectionUrl(targetUrl, sectionId).toString(), {
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
      .then(function(response) {
        if (!response.ok) {
          throw new Error('Section request failed');
        }
        return response.json();
      })
      .then(function(payload) {
        if (requestId !== navigationRequestId) return;

        var sectionHtml = payload && payload[sectionId];
        if (!sectionHtml) {
          throw new Error('Section response missing main product HTML');
        }

        replaceProductSection(section, sectionHtml);

        if (updateHistory) {
          var cleanUrl = new URL(targetUrl, window.location.origin);
          cleanUrl.searchParams.delete('sections');
          window.history.pushState({ cpilotFamilyNavigation: true }, '', cleanUrl.toString());
        }
      })
      .catch(function() {
        window.location.assign(targetUrl);
      })
      .finally(function() {
        section.classList.remove('cpilot-family-navigation-is-loading');
      });
  }

  function bindNavigation(nav) {
    if (nav.dataset.cpilotAjaxBound === 'true') return;
    nav.dataset.cpilotAjaxBound = 'true';

    initializeSizeIntent(nav);
    updateAvailability(nav);

    var clearSizeButton = nav.querySelector(CLEAR_SIZE_SELECTOR);
    if (clearSizeButton) {
      clearSizeButton.addEventListener('click', function() {
        clearSizeIntent(nav);
        updateAvailability(nav);

        var activeItem = nav.querySelector(ITEM_SELECTOR + '.is-active') || nav.querySelector(ITEM_SELECTOR);
        if (activeItem) {
          activeItem.focus();
        }
      });
    }

    nav.addEventListener('click', function(event) {
      var item = event.target.closest(ITEM_SELECTOR);
      if (!item || !nav.contains(item)) return;

      if (event.defaultPrevented || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) {
        return;
      }

      event.preventDefault();

      if (item.dataset.cpilotUnavailable === 'true') {
        announceUnavailable(nav, item);
        return;
      }

      if (item.classList.contains('is-active')) {
        return;
      }

      var targetUrl = item.href || item.dataset.cpilotProductUrl;
      if (!targetUrl) return;

      navigateToProduct(targetUrl, nav);
    });

    nav.addEventListener('keydown', function(event) {
      var item = event.target.closest(ITEM_SELECTOR);
      if (!item || !nav.contains(item) || item.dataset.cpilotUnavailable !== 'true') return;
      if (event.key !== 'Enter' && event.key !== ' ') return;

      event.preventDefault();
      announceUnavailable(nav, item);
    });

    var productScope = getProductScope(nav);
    productScope.addEventListener('click', function(event) {
      if (!event.target.closest('variant-picker .option-selector[data-option="Size"]')) {
        return;
      }

      setExplicitSizeIntent(nav, 'user');
      window.setTimeout(function() {
        updateAvailability(nav);
      }, 0);
    });

    productScope.addEventListener('change', function(event) {
      if (event.target && event.target.closest('variant-picker .option-selector[data-option="Size"]')) {
        setExplicitSizeIntent(nav, 'user');
      }

      if (event.target && event.target.closest('variant-picker')) {
        window.setTimeout(function() {
          updateAvailability(nav);
        }, 0);
      }
    });

    productScope.addEventListener('on:variant:change', function() {
      if (currentUrlHasVariant() && nav.dataset.cpilotSizeIntent === 'none') {
        setExplicitSizeIntent(nav, 'url');
      }

      window.setTimeout(function() {
        updateAvailability(nav);
      }, 20);
    });
  }

  function initCommercePilotFamilyNavigation(root) {
    var scope = root || document;
    var navs = [];

    if (scope.matches && scope.matches(NAV_SELECTOR)) {
      navs.push(scope);
    }

    scope.querySelectorAll(NAV_SELECTOR).forEach(function(nav) {
      navs.push(nav);
    });

    navs.forEach(bindNavigation);
  }

  window.CommercePilotFamilyNavigation = window.CommercePilotFamilyNavigation || {};
  window.CommercePilotFamilyNavigation.init = initCommercePilotFamilyNavigation;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initCommercePilotFamilyNavigation(document);
    }, { once: true });
  } else {
    initCommercePilotFamilyNavigation(document);
  }

  window.addEventListener('popstate', function() {
    var nav = document.querySelector(NAV_SELECTOR);
    if (!nav) return;
    navigateToProduct(window.location.href, nav, { updateHistory: false });
  });

  document.addEventListener('shopify:section:load', function(event) {
    initCommercePilotFamilyNavigation(event.target || document);
  });
})();
